'use strict';

var React = require('react');
var Typography = require('./Typography-fd6f932a.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Heading({ level = 5, children }) {
    const levelMap = {
        1: {
            element: "h1",
            size: "jumbo",
            fontWeight: "black",
            textColor: "heading",
        },
        2: {
            element: "h2",
            size: "largest",
            fontWeight: "black",
            textColor: "heading",
        },
        3: {
            element: "h3",
            size: "larger",
            fontWeight: "extraBold",
            textColor: "heading",
        },
        4: {
            element: "h4",
            size: "large",
            fontWeight: "bold",
            textColor: "heading",
        },
        5: {
            element: "h5",
            size: "base",
            fontWeight: "bold",
            textColor: "heading",
        },
        6: {
            element: "h6",
            size: "small",
            textCase: "uppercase",
            fontWeight: "bold",
            textColor: "heading",
        },
    };
    return React__default["default"].createElement(Typography.Typography, Object.assign({}, levelMap[level]), children);
}

exports.Heading = Heading;
